import React from 'react';
import {Input, Modal, Select, Typography} from 'antd';

const {Text} = Typography;

type Props = {
	open: boolean;
	name: string;
	onNameChange: (value: string) => void;
	onOk: () => void;
	onCancel: () => void;
	confirmLoading?: boolean;
};

const CreateDiagram: React.FC<Props> = ({
	open,
	name,
	onNameChange,
	onOk,
	onCancel,
	confirmLoading = false,
}) => (
	<Modal
		title="Новая диаграмма"
		open={open}
		onOk={onOk}
		onCancel={onCancel}
		confirmLoading={confirmLoading}
		cancelText="Отменить"
		okText="Создать"
	>
		<div style={{display: 'flex', flexDirection: 'column', gap: 16, marginTop: 16}}>
			<div>
				<Text strong>Тип диаграммы</Text>
				<br />
				<Select
					value="ARCHIMATE"
					disabled
					style={{width: '100%', marginTop: 4}}
					options={[{value: 'ARCHIMATE', label: 'ArchiMate'}]}
				/>
			</div>
			<div>
				<Text strong>Название диаграммы</Text>
				<br />
				<Input
					value={name}
					onChange={e => onNameChange(e.target.value)}
					placeholder="Название"
					style={{
						width: '100%',
						marginTop: 4,
					}}
				/>
			</div>
		</div>
	</Modal>
);

export default CreateDiagram;
